/* eslint-disable */

import React, { useEffect, useRef, useState } from 'react'
import { StyleSheet } from 'aphrodite'
import { getCurrency, getMeasurement } from '../../utils/types'
import { useDeleteRequest, usePutRequest } from '../../hooks/request'
import { NOMENCLATURE_DETAIL, domain } from '../../urls'
import Button from '../../components/common/Button'
import { useModal } from '../../hooks/modal'
import ProductUpdate from '../../components/ProductUpdate'
import { useReactToPrint } from 'react-to-print'
import { useCustomModal } from '../../hooks/customModal'

// Debounce function
function debounce(fn, delay) {
    let timeoutId
    return (...args) => {
        if (timeoutId) {
            clearTimeout(timeoutId)
        }
        timeoutId = setTimeout(() => {
            fn(...args)
        }, delay)
    }
}

export default function PromotionColumn({ item, index, products }) {
    const productUpdate = usePutRequest({ url: NOMENCLATURE_DETAIL.replace('{id}', item?.id) })

    const [price, setPrice] = useState(item?.price)
    const [priceSale, setPriceSale] = useState(item?.priceSale)
    const [priceTransfer, setPriceTransfer] = useState(item?.priceTransfer)
    const [count, setCount] = useState(item?.count || 0) // New state for count
    const [showUpdateModal, setShowUpdateModal] = useModal(<ProductUpdate products={products} item={item?.selectProducts} hideModal={() => setShowUpdateModal()} />, styles.modal)

    // Debounced updateProduct function
    const debouncedUpdateProduct = debounce(async (field, value) => {
        try {
            await productUpdate.request({ data: { [field]: value, name: item?.name } })
        } catch (error) {
            console.log(error, 'error')
        }
    }, 500)

    useEffect(
        () => () => {
            debouncedUpdateProduct.cancel?.()
        },
        [debouncedUpdateProduct],
    )

    const handleInputChange = (e, type) => {
        const value = e?.target?.value
        let field = ''

        switch (type) {
            case 'price':
                field = 'price'
                setPrice(value)
                break
            case 'priceSale':
                field = 'priceSale'
                setPriceSale(value)
                break
            case 'priceTransfer':
                field = 'priceTransfer'
                setPriceTransfer(value)
                break
            case 'count': // New case for count
                field = 'count'
                setCount(value)
                break
            default:
                return
        }

        debouncedUpdateProduct(field, value)
    }

    const componentRef = useRef()
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    })
    // console.log(item)
    const productRemove = useDeleteRequest({ url: NOMENCLATURE_DETAIL.replace('{id}', item?.id) })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            await products.request()
        }
    }

    console.log(item)
    const [showImageModal] = useCustomModal(
        item?.selectProducts.image ? (
            <img src={domain + item?.selectProducts.image} alt={item?.selectProducts.name || 'Product image'} />
        ) : (
            <div style={{
                padding: '20px',
                textAlign: 'center',
                color: '#999',
                fontSize: '16px'
            }}>
                <i className="fas fa-image" style={{ fontSize: '48px', marginBottom: '10px' }} />
                <p>📷 Изображение отсутствует.</p>

            </div>
        )
    )


    const imageStyle = {
        width: '40px',
        height: '40px',
        objectFit: 'cover',
        borderRadius: '4px',
        border: '1px solid #ddd'
    }

        // Default image placeholder
    const defaultImageStyle = {
        width: '40px',
        height: '40px',
        backgroundColor: '#f5f5f5',
        border: '1px solid #ddd',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#999',
        fontSize: '12px',
        textAlign: 'center'
    }
    return (
        <>
            <tr className="is-size-6" key={item?.id || index}>

                <td className="is-size-6 is-capitalized">
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {item?.selectProducts.image ? (
                        <img
                            onClick={showImageModal}
                            src={domain + item?.selectProducts.image}
                            alt={item?.selectProducts.name}
                            style={imageStyle}
                        />
                    ) : (
                        <div onClick={showImageModal} style={defaultImageStyle}>
                            <ion-icon name="image-outline" />
                        </div>
                    )}
                    <span>{item?.selectProducts?.name}</span>
                </div>
            </td>

                <td>
                    <div className="is-flex">
                        <input
                            style={{ width: 100 }}
                            value={count || ''}
                            type="number"
                            className="is-size-7 input is-small mr-2" // Input for count
                            name={`products.${index}.count`}
                            onChange={(e) => handleInputChange(e, 'count')}
                        />
                        {getMeasurement(item?.measurement)}
                    </div>
                </td>
                <td>
                    <input value={price || ''} type="number" className="is-size-7 input is-small" name={`products.${index}.price`} onChange={(e) => handleInputChange(e, 'price')} />
                </td>
                <td>
                    <input value={priceTransfer || ''} type="number" className="is-size-7 input is-small" name={`products.${index}.priceTransfer`} onChange={(e) => handleInputChange(e, 'priceTransfer')} />
                </td>
                <td>
                    <input value={priceSale || ''} type="number" className="is-size-7 input is-small" name={`products.${index}.priceSale`} onChange={(e) => handleInputChange(e, 'priceSale')} />
                </td>

                <td>{getCurrency(item?.paymentType)}</td>

                <td>
                    <div style={{ display: 'flex', alignItems: 'center' }} className="is-pulled-right">
                        <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small" icon="pencil-outline" />
                        <Button onClick={onDelete} className="button is-danger is-outlined is-small" icon="trash" />
                    </div>
                </td>
            </tr>
        </>
    )
}

const ImageModal = ({ item, domain, hideModal }) => {
    return (
        <div style={{ textAlign: 'center' }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px',
                borderBottom: '1px solid #eee',
                paddingBottom: '10px'
            }}>
                <h3 style={{ margin: 0 }}>{item?.selectProducts?.name}</h3>
                <Button
                    onClick={hideModal}
                    className="button is-small"
                    icon="close"
                />
            </div>

            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '300px'
            }}>
                {item?.selectProducts?.image ? (
                    <img
                        src={`${domain}${item?.selectProducts?.image}`}
                        alt={item?.selectProducts?.name}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '70vh',
                            objectFit: 'contain',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                        }}
                        onError={(e) => {
                            console.log('Image failed to load:', e.target.src);
                            e.target.style.display = 'none';
                        }}
                    />
                ) : (
                    <div style={{
                        width: '300px',
                        height: '300px',
                        backgroundColor: '#f5f5f5',
                        border: '2px dashed #ddd',
                        borderRadius: '8px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto'
                    }}>
                        <ion-icon name="image-outline" style={{ fontSize: '48px', color: '#999', marginBottom: '10px' }} />
                        <span style={{ color: '#999', fontSize: '14px' }}>Rasm mavjud emas</span>
                    </div>
                )}
            </div>

            <div style={{ marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                <Button
                    onClick={hideModal}
                    className="button is-primary"
                >
                    Yopish
                </Button>
            </div>
        </div>
    )
}

const styles = StyleSheet.create({
    tr: { ':nth-child(1n) > td': { lineHeight: 1 } },
    center: { display: 'flex', alignItems: 'center' },
    td1: { display: 'flex', alignItems: 'center', gap: '5px', lineHeight: 1, cursor: 'pointer' },
    td1Img: { width: 32, height: 32, borderRadius: '50%', objectFit: 'cover' },
    td1Right: {},
    td1RightTitle: { fontFamily: 'GilroySemi', color: '#333333', lineHeight: '19px' },
    td1RightSubtitle: {
        marginTop: '1px',
        fontFamily: 'Gilroy',
        fontSize: '14px',
        color: 'rgba(51, 51, 51, 0.7)',
        lineHeight: '16px',
    },
    industries: { display: 'flex', whiteSpace: 'nowrap', flexWrap: 'wrap' },
    modal: { width: 1000 },
    icon: { fontSize: '20px', padding: 10 },
})
